import type { FeedbackStatus } from '@feedback-system/types';

const STATUS_COLORS: Record<FeedbackStatus, string> = {
  open: 'bg-accent-primary/20 text-accent-primary',
  in_review: 'bg-accent-orange/20 text-accent-orange',
  resolved: 'bg-accent-green/20 text-accent-green',
  closed: 'bg-dark-200/20 text-dark-200',
};

export function StatusBadge({ status }: { status: FeedbackStatus }) {
  return (
    <span className={`badge ${STATUS_COLORS[status]}`}>
      {status === 'in_review' ? 'In Review' : status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}
